import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone'
})

export class PhonePipe implements PipeTransform {
    transform(val, format) {
        let newStr = '';
        let i;
        if (format === 'phone') {
            for (i = 0; i < 2; i++) {
                newStr = newStr + val.substr(i * 1, 3) + '-';
            }
            return newStr + val.substr(i * 3);
        }
        if (format === 'telephone') {
            for (i = 0; i < 2; i++) {
                newStr = newStr + val.substr(i * 1, 3) + '-';
            }
            return newStr + val.substr(i * 3);
        }
    }
}
